import {BaseModel} from "../../../../infrastructure/models/base-model";

export class DidomiConfigThemeModel extends BaseModel {
  language: String;

  constructor(language: String) {
    super();

    this.language = language;
  }

  getDidomiObject() {
    return {
      css: `
        body.didomi-popup-open {
          overflow: auto !important;
          min-height: 100vh;
        }
        
        body.didomi-popup-open-ios {
          position: relative;        
        }
        
        .didomi-rtl  {
          direction: rtl;
        }
        
        #didomi-host {
          font-family: '365 Sans', 'Roboto', sans-serif;
          color: var(--textPrimary);
          background-color: var(--surfaceSecondary) !important;
        }
        
        #didomi-host div {
          background-color: var(--surfacePrimary) !important;
          color: var(--textPrimary); !important;
        } 
        
        #didomi-host span {
          color: var(--textPrimary); !important;
        }
        
        #didomi-host .didomi-popup__backdrop.didomi-notice-popup .didomi-popup-view {
          display: flex;
          flex-direction: column;
        }
        
        #didomi-host .didomi-popup-notice.didomi-popup-notice-with-data-processing h1 {
            margin-bottom: 10px !important;
        }       
        
        #didomi-host .didomi-popup-notice.didomi-popup-notice-with-data-processing {
          padding: 20px 21px 0px 12px !important;
          box-shadow: 1px 7px 17px 3px rgb(0 0 0 / 25%);
          background-color: var(--surfaceSecondary);
        }
        
        #didomi-host .didomi-mobile .didomi-consent-popup-preferences-purposes .didomi-consent-popup-footer {
          position: sticky;
          bottom: 0;
          background-color: var(--surfaceSecondary);
          box-shadow: 1px 7px 17px 3px rgb(0 0 0 / 35%);
        }
        
        #didomi-host #didomi-notice.didomi-regular-notice.shape-banner {
          padding: 2em 1.8em;
        }
        
        #didomi-host .didomi-popup-backdrop {
          background-color: rgba(0,0,0,0.3) !important;
        }
        
        #didomi-host .didomi-popup-container {
          border-radius: 0 !important;
          background-color: var(--surfaceSecondary);
          border: none;
        }
        
        #didomi-host .didomi-popup-notice {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          min-width: 100%;
        }
        
        #didomi-host .didomi-exterior-border {
          border-style: none !important;
          padding: 0 !important;
        }
        
        #didomi-host .didomi-consent-popup-body {
          padding: 10px 20px;
        }
        
        #didomi-host .didomi-notice-banner {
          box-shadow: 1px 7px 17px 3px rgba(0,0,0,0.25);
        }
        
        #didomi-host .didomi-mobile #didomi-notice.didomi-regular-notice.bottom, #didomi-host .didomi-mobile #didomi-notice.didomi-regular-notice.bottom .didomi-notice__interior-border {
          border-style: none;
        }
        
        #didomi-host .didomi-mobile #didomi-notice.didomi-regular-notice.bottom .didomi-notice__interior-border {
          border-style: none;
        }
        
        #didomi-host .didomi-notice-data-processing-container {
          padding: 10px 0;
        }
        
        #didomi-host .didomi-mobile .didomi-popup-notice-buttons {
          margin-top: 0 !important;
          margin-bottom: 10px !important;
          flex-direction: row;
        }
        
        #didomi-host .didomi-popup-notice .didomi-popup-notice-subtext, #didomi-host .didomi-popup-notice .didomi-popup-notice-text {
          max-width: unset;
          line-height: 1.2;
          color: var(--textPrimary);
          font-size: 13px;
        }
        
        #didomi-host .didomi-mobile .didomi-notice-data-processing-container .didomi-notice-data-processing-list, #didomi-host .didomi-mobile .didomi-notice-data-processing-container .didomi-notice-data-processing-title {
          line-height: 1.2;
        }
        
        #didomi-host .didomi-consent-popup-body .didomi-consent-popup-body__title {
          color: var(--textSecondary);
        }
        
        #didomi-host #didomi-notice.didomi-regular-notice a {
          color: var(--accentPrimary);
        }
        
        #didomi-host #didomi-notice.didomi-regular-notice.didomi-regular-notice-with-data-processing .didomi-notice-text {
          color: var(--textPrimary);
        }
        
        #didomi-host .didomi-notice-data-processing-container .didomi-notice-data-processing-list {
          font-weight: 500;
          color: var(--textPrimary);
        }
        
        #didomi-host p {
          color: var(--textPrimary);
          line-height: 1.2;
        }
        
        #didomi-host .didomi-popup-header {
          color: var(--textPrimary);
          font-size: 20px;
        }
        
        #didomi-host .didomi-consent-popup-preferences-purposes-features {
          line-height: 1.2;
          color: var(--textPrimary);
        }
        
        #didomi-host .didomi-consent-popup-preferences-purposes .didomi-consent-popup-footer .didomi-consent-popup-actions .didomi-consent-popup-information-save {
          font-style: initial;
          color: var(--textSecondary);
        }
        
        #didomi-host .didomi-consent-popup-body .didomi-consent-popup-body__explanation a {
          font-weight: 500;
          text-decoration: underline;
        }
        
        #didomi-host .didomi-components-accordion .didomi-content.active {
          padding: 10px 15px 0 15px;
          background-color: var(--surfacePrimary);
          color: var(--textPrimary) !important;
        }
        
        #didomi-host .didomi-popup-notice .didomi-popup-notice-buttons {
            margin-top: -40px;
            margin-bottom: 16px;
        }
        
        
        #didomi-host .didomi-screen-xsmall .didomi-popup-notice-buttons {
            margin-top: 0;
        }
        
        #didomi-host .didomi-notice-data-processing-container {
            text-align: unset;
            width: 70%;
            min-height: 20px;
        }
        
        #didomi-host .didomi-mobile .didomi-notice-data-processing-container {
            width: 100%;
        }
        
        #didomi-host .didomi-mobile .didomi-notice-data-processing-container {
            min-height: 0;
        }
        
        #didomi-host .didomi-consent-popup-preferences-vendors .didomi-user-information-container {
          border: none;
          font-size: 12px;
          line-height: 1.4;
          color: var(--textPrimary);
        }
        
        #didomi-host .didomi-notice-data-processing-container .didomi-notice-data-processing-title {
          display: ${!this.language ? 'none' : 'inherit'};
          color: var(--textPrimary);
        }
        
        #didomi-host .didomi-notice-data-processing-container .didomi-notice-data-processing-list {
          display: ${!this.language ? 'none' : 'inherit'}
        }
        
        #didomi-host .didomi-button-highlight {
          color: var(--secondaryText) !important;
        }
        
        #didomi-host .didomi-button-standard {
          color: var(--surfaceSecondary) !important;
          background-color: transparent !important;
          padding: 0 .8em .4em .8em !important;
          height: 12px !important;
          border: none !important;
        }
        
        #didomi-host .didomi-components-button {
          height: 32px;
          border-radius: 20px !important;
          font-size: 14px !important;
          line-height: 1
        }
        
        #didomi-host a.didomi-no-link-style {
          color: var(--textSecondary);
          opacity: 1;
        }
        
        #didomi-host .didomi-consent-popup-preferences {
          direction: ltr;
        }
        
        #didomi-host .didomi-consent-popup-preferences .didomi-consent-popup-data-processing, #didomi-host .didomi-consent-popup-preferences .didomi-consent-popup-vendor {
          color: var(--textPrimary);
          font-size: 14px;
        }
        
        #didomi-host :focus {
          outline: none;
        }
        
        /* internal buttons */
        #didomi-host .didomi-popup-notice .didomi-notice-view-partners-link {
          display: flex;
          margin-top: 10px;
        }
        
        #didomi-host .didomi-popup-notice .didomi-popup-notice-buttons {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-wrap: wrap;
        }
        
        #didomi-host .didomi-popup-notice .didomi-popup-notice-buttons .didomi-button {
          padding: .4em .8em;
          white-space: nowrap;
          margin: 5px 0 0 0;
          min-width: 100px;
        }
        
        #didomi-host .didomi-consent-popup-preferences-purposes .didomi-consent-popup-view-vendors-list .didomi-consent-popup-view-vendors-list-link {
          color: var(--textSecondary);
          box-shadow: none;
          border: 1px solid var(--textSecondary);
          background-color: var(--surfaceSecondary);
        }
        
        #didomi-host .didomi-components-radio__option.didomi-components-radio__option--disagree {
          background-color: var(--dangerPrimary);
          color: var(--secondaryText);
          border: 1px solid var(--dangerPrimary);
          padding: 0px 6px;
        }
        
        #didomi-host .didomi-components-radio__option.didomi-components-radio__option--disagree {
          background-color: var(--dangerPrimary);
          color: var(--secondaryText);
          border: 1px solid var(--dangerPrimary);
          padding: 0px 6px;
        }
        
        #didomi-host .didomi-components-radio__option.didomi-components-radio__option--agree {
          background-color: var(--successPrimary);
          color: var(--secondaryText);
          border: 1px solid var(--successPrimary);
          padding: 0px 6px;
        }
        
        #didomi-host .didomi-components-radio__option.didomi-components-radio__option--agree:hover {
          background-color: var(--successPrimary);
          color: var(--secondaryText);
          border: 1px solid var(--successPrimary);
          padding: 0px 6px;
        }
        
        #didomi-host .didomi-components-radio__option:focus {
          outline: none;
        }
        
        #didomi-host .didomi-components-radio__option {
          width: 90px;
          padding: 0;
          font-weight: 500;
          box-shadow: none;
          border: 1px solid var(--textSecondary);
          color: var(--textSecondary);
          background-color: transparent;
        }
        
        #didomi-host .didomi-components-radio__option::hover {
          color: var(--textSecondary);
          border-color: var(--textSecondary);
        }
        
        #didomi-host .didomi-consent-popup-preferences-vendors .didomi-user-information-trigger {
          color: var(--textSecondary);
        }
        
        #didomi-host {
          -webkit-tap-highlight-color: transparent;
        }
        
        #didomi-host .didomi-popup-notice .didomi-notice-view-partners-link {
          display: none;
        }
        
        #didomi-host .didomi-mobile .didomi-popup-notice-text-container {
          max-height: 200px;
          overflow-y: scroll;
        }
        
        #didomi-host .didomi-consent-popup-preferences-vendors .didomi-consent-popup-body_vendors-list {
          color: var(--textPrimary);
        }
        
        #didomi-host .didomi-consent-popup-preferences-purposes .didomi-consent-popup-data-processing__purpose_actions {
          background-color: var(--surfacePrimary);
        }
        
        #didomi-host .didomi-consent-popup-preferences-purposes .didomi-consent-popup-data-processing__purpose_actions .didomi-consent-popup-data-processing__purpose_actions_title {
          color: var(--textPrimary);
        }

        #didomi-host .didomi-popup-footer {
          background-color: var(--surfacePrimary);
        }
        
        #didomi-host .didomi-popup-close {
          text-shadow: 0 1px 0 var(--surfaceSecondary);
        }
      `
    }
  }
}